const souvenirsDate = [
    {
        id: 1,
        price: "10",
        tourlang: "rus",
        name: "Органайзер",
        img: "img/souvenirs/1",
    },
    {
        id: 2,
        price: "10",
        tourlang: "eng",
        name: "Органайзер",
        img: "img/souvenirs/1",
    },
    {
        id: 3,
        price: "10",
        tourlang: "rus",
        name: "Органайзер",
        img: "img/souvenirs/2",
    },
    {
        id: 4,
        price: "10",
        tourlang: "eng",
        name: "Органайзер",
        img: "img/souvenirs/2",
    },
    {
        id: 5,
        price: "10",
        tourlang: "rus",
        name: "Органайзер",
        img: "img/souvenirs/3",
    },
    {
        id: 6,
        price: "10",
        tourlang: "eng",
        name: "Органайзер",
        img: "img/souvenirs/3",
    },
    {
        id: 7,
        price: "10",
        tourlang: "rus",
        name: "Органайзер",
        img: "img/souvenirs/4",
    },
    {
        id: 8,
        price: "10",
        tourlang: "eng",
        name: "Органайзер",
        img: "img/souvenirs/4",
    },
    {
        id: 9,
        price: "10",
        tourlang: "rus",
        name: "Органайзер",
        img: "img/souvenirs/5",
    },
    {
        id: 10,
        price: "10",
        tourlang: "eng",
        name: "Органайзер",
        img: "img/souvenirs/5",
    },
]
export default souvenirsDate;